export const routes = [
    {
        path: "/",
        redirect: "/index"
    },
    {
        path: "/login",
        component: () => import('@/pages/login/index.vue'),
    },
    {
        path: "/index",
        redirect: "/home",
    },
    {
        path: '/home',
        component: () => import('@/pages/home/index.vue'),
    },
    {
        path: '/userinfo',
        component: () => import('@/pages/home/userinfo.vue'),
    },
    {
        path: '/print/index',
        component: () => import('@/pages/print/index.vue'),
    },
    {
        path: '/main-report',
        component: () => import('@/pages/report/index.vue'),
    },
];
